import React from 'react';
import { useAuth } from '../../../../hooks/useAuth';
import { Link } from 'react-router-dom';
import './CreateYourAccount.css';

function CreateYourAccount() {
  const { isAuthenticated } = useAuth();
  const linkPath = isAuthenticated ? "/Profile" : "/New-Account";
  const buttonText = isAuthenticated ? "View Your Account" : "Create Your Account";

  return (
    <div className="createyouraccount-container">
      <div className="createyouraccount-topimage"></div>
      <div className="createyouraccount-title">
        Bringing your dog? You’ll need an account!
      </div>
      <Link to={linkPath}>
        <button className="createyouraccount-button">{buttonText}</button>
      </Link>
      <div className="createyouraccount-subtitle">
        You'll add your dog's info to your profile, and we'll verify their vaccination records in person. 
        Setting up your account in advance makes check-in quicker for everyone! <br /><br />
        Additionally, you can manage your dog's vaccination records and personal information, keep track of your memberships and visit history, 
        and securely update your user account details and saved payment information.
     </div>
      <div className="createyouraccount-image-container">
      <img
        className="createyouraccount-dogcard"
        src="/CreateYourAccountDogCard.png"
        alt="Dog Card"
      />
      <img
        className="createyouraccount-memberships"
        src="/CreateYourAccountMemberships.png"
        alt="Memberships"
      />
      </div>
      <div className="createyouraccount-bottomimage"></div>
    </div>
  );
}

export default CreateYourAccount;
